<template>
    <div class="modal fade" id="modal_edit_member" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div v-if="requestMember" class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestMember" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('layout.navbar.modal.edit_member.title') }}

                    </h5>
                    <button @click="closeModal('modal_edit_member', 'edit')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestMember">
                    <form class="forms-sample" @submit.prevent="submitForm">
                        <div class="row  mb-3">
                            <div class="col-md-12">
                                <DynamicToggle :text="i18n.t('tables.members.sync_image_to_pointeuse')"
                                    v-model="requestMember.sync_image_to_pointeuse" name="sync_image_to_pointeuse"
                                    id="sync_image_to_pointeuse" />
                            </div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-md-6  mb-2">
                                <radioInput v-model="isCaputre" :valueAttr="1" :label="i18n.t('button.upload_image')"
                                    :name="`isCaputre`" :id="`isCaputre-1`" />
                            </div>
                            <div class="col-md-6  mb-2">
                                <radioInput v-model="isCaputre" :valueAttr="0" :label="i18n.t('button.take_photo')"
                                    :name="`isCaputre`" :id="`isCaputre-0`" />
                            </div>
                        </div>
                        <div class="row  mb-4">
                            <div v-if="isCaputre" class="col-md-12 mb-3">
                                <div class="form-group mr-b-0em">
                                    <input-image v-model="requestMember.path_image"
                                        :label="i18n.t('tables.members.name')" :pathImage="requestMember.path_image"
                                        :disabled="false" />
                                </div>
                            </div>
                            <div v-if="!isCaputre" class="col-md-12">
                                <capture-photo v-model="requestMember.path_image" :pathImage="requestMember.path_image"
                                    :v="v$.path_image" />
                            </div>
                        </div>
                        <div class=" row">
                            <!-- <div class="col-md-6 mb-3">
                                <div class="form-group ">
                                    <inputText v-model="requestMember.card_id"
                                        :label="i18n.t('tables.members.card_id')" :v="v$.card_id"
                                        :disabled="false" />
                                </div>
                            </div> -->
                            <div class="col-md-6 mb-3">
                                <div class="form-group ">
                                    <inputText v-model="requestMember.matricule"
                                        :label="i18n.t('tables.members.matricule')" :v="v$.matricule"
                                        :disabled="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestMember.contractNumber"
                                        :label="i18n.t('tables.members.contractNumber')" :v="v$.contractNumber"
                                        :disabled="true" />
                                </div>
                            </div>
                            <div class="col-md-12">
                                <SingleSelect :TextLabel="i18n.t('tables.members.seller')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestMember.seller_id"
                                    :placeholder="i18n.t('tables.members.seller')" :arrayOptions="employeesSellersList"
                                    refs="sellers" :v="v$.seller_id" />
                            </div>

                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <SingleSelect :TextLabel="i18n.t('tables.members.age_category')" :trackby="`id`"
                                        :label="`name`" :valueProp="`id`" v-model="requestMember.age_category"
                                        :placeholder="i18n.t('tables.members.age_category')"
                                        :arrayOptions="targetAgeList" refs="age_category" :v="v$.age_category" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <SingleSelect :TextLabel="i18n.t('tables.members.gender')" :trackby="`id`"
                                        :label="`name`" :valueProp="`id`" v-model="requestMember.gender"
                                        :placeholder="i18n.t('tables.members.gender')" :arrayOptions="filteredGenders"
                                        refs="gender" :v="v$.gender" />
                                </div>
                            </div>

                            <div v-if="requestMember.age_category == 'minor' || requestMember.gender == 2 || requestMember.gender == 3" class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestMember.parent_name" :label="i18n.t('tables.members.parent_name')"
                                        :v="v$.parent_name" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestMember.name" :label="i18n.t('tables.members.name')"
                                        :v="v$.name" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestMember.email" :label="i18n.t('tables.members.email')"
                                        :v="v$.email" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group ">

                                    <phone-number v-model="requestMember.tele" :label="i18n.t('tables.members.tele')"
                                        :v="v$.tele" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestMember.cin" :label="i18n.t('tables.members.cin')"
                                        :v="v$.cin" :disabled="false" />
                                </div>
                            </div>


                          
                            <div class="col-md-6">
                                <div class="form-group ">
                                    <date-field v-model="requestMember.dateBirth"
                                        :label="i18n.t('tables.members.dateBirth')" :v="v$.dateBirth" :fixedDays="1"
                                        :isFixedDays="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group ">
                                    <inputText v-model="requestMember.occupation"
                                        :label="i18n.t('tables.members.occupation')" :v="v$.occupation"
                                        :disabled="false" />
                                </div>
                            </div>


                            <div class="col-md-12">
                                <div class="form-group ">
                                    <inputTextarea v-model="requestMember.adresse"
                                        :label="i18n.t('tables.members.adresse')" :v="v$.adresse" :disabled="false" />
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group ">
                                    <inputTextarea v-model="requestMember.comment"
                                        :label="i18n.t('tables.members.comment')" :v="v$.comment" :disabled="false" />
                                </div>
                            </div>



                            <div class="col-md-6 text-right">

                                <button type="button" @click="closeModal('modal_edit_member', 'edit')"
                                    class="w-100 btn btn-cancel">
                                    {{ i18n.t('button.close') }}
                                </button>
                            </div>
                            <div class="col-md-6 text-right">
                                <button type="submit" class="w-100 btn btn-primary mr-2">
                                    {{ i18n.t('button.edit') }}
                                </button>
                            </div>


                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">

// ============================================================
// Imports
// ============================================================

import Swal from "sweetalert2";
import i18n from "@/i18n/index";

import {
    defineComponent,
    ref,
    computed,
    watch,
    toRefs,
    nextTick,
} from "vue";

// Components
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
import inputTextarea from "@/components/inputsValidation/ReusableTextarea.vue";
import radioInput from "@/components/inputsValidation/radioInput.vue";
import checkboxInput from "@/components/inputsValidation/checkboxInput.vue";
import DynamicToggle from "@/components/inputsValidation/DynamicToggle.vue";

// Composables
import { useModal } from "@/composables/modal/useModal";
import { useMember } from "@/composables/member/useMember";
import { useImageConverter } from "@/composables/global/useImageConverter";
import { useTrainer } from "@/composables/trainer/useTrainer";
import { usePermission } from "@/composables/auth/usePermission";

// Interfaces
import { MemberEditRequest } from "@/interfaces/member";
import { TrainerSearchParams } from "@/interfaces/trainer";

// Shared state
import {
    genders,
    trainers,
    fiche_member,
    clubUUID,
    targetAge,
} from "@/shared/state";

// Validation
import { useVuelidate } from "@vuelidate/core";
import {
    required,
    helpers,
    minLength,
    email,
    maxLength,
} from "@vuelidate/validators";


// ============================================================
// Component
// ============================================================

export default defineComponent({

    name: "component-inscription",

    components: {
        inputText,
        inputTextarea,
        SingleSelect,
        radioInput,
        checkboxInput,
        DynamicToggle,
    },

    props: {
        member: {
            type: Object,
            default: null,
        },

        editFrom: {
            type: String,
            default: null,
        },
    },

    setup(props) {

        // ========================================================
        // Props
        // ========================================================

        const { member, editFrom } = toRefs(props);


        // ========================================================
        // Composables
        // ========================================================

        const { closeModal } = useModal();
        const { hasPermission } = usePermission();

        const {
            editMember,
            isRequestMember,
            errorMember,
        } = useMember();

        const {
            fetchTrainers,
        } = useTrainer();

        const {
            selectedImage,
            error,
            handleFileChange,
        } = useImageConverter();


        // ========================================================
        // Constants
        // ========================================================

        const APP_URL = process.env.VUE_APP_URL;


        // ========================================================
        // State
        // ========================================================

        const action = ref("edit");

        const isCaputre = ref<any>(0);

        /**
         * Prevent watchers from modifying values
         * while the form is being initialized.
         */
        const isInitializing = ref(false);


        const requestMember = ref<MemberEditRequest>({
            id: null,
            card_id: null,
            matricule: null,
            name: null,
            parent_name: null,
            email: null,
            tele: null,
            cin: null,
            adresse: null,
            age_category: null,
            gender: null,
            dateBirth: null,
            contractNumber: null,
            occupation: null,
            comment: null,
            seller_id: null,
            path_image: null,
            sync_image_to_pointeuse: true,
        });


        const searchByEmployees = ref<TrainerSearchParams>({
            id: null,
            clubUUID: clubUUID.value,
            personType: "seller",
            trainerUUID: null,
            matricule: "",
            name: "",
            email: "",
            tele: "",
            cin: "",
            gender: null,
            contractNumber: "",
            type: "all",
            page: null,
            limit: null,
            trainerToPayThisMonth: null,
            with_advances: "false",
        });


        // ========================================================
        // Computed
        // ========================================================

        const targetAgeList = computed(() => targetAge.value);

        const employeesSellersList = computed(() => trainers.data);

        const filteredGenders = computed(() => {

            const ageCategory = requestMember.value.age_category;

            if (ageCategory === "adult") {
                return genders.value.filter(
                    gender => gender.id === 0 || gender.id === 1
                );
            }

            if (ageCategory === "minor") {
                return genders.value.filter(
                    gender => gender.id === 2 || gender.id === 3
                );
            }

            return genders.value;
        });


        // ========================================================
        // Validation
        // ========================================================

        const rules = {

            name: {
                required: helpers.withMessage(
                    i18n.t("validation.required"),
                    required
                ),

                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", {
                        value: 2,
                        attribute: "",
                    }),
                    minLength(2)
                ),
            },

            email: {
                email,
            },

            tele: {
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", {
                        value: 10,
                        attribute: "",
                    }),
                    minLength(10)
                ),

                maxLength: helpers.withMessage(
                    i18n.t("validation.min.string", {
                        value: 14,
                        attribute: "",
                    }),
                    maxLength(14)
                ),
            },

            cin: {
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", {
                        value: 4,
                        attribute: "",
                    }),
                    minLength(4)
                ),
            },

            adresse: {},

            dateBirth: {},

            gender: {
                required: helpers.withMessage(
                    i18n.t("validation.required"),
                    required
                ),
            },

            age_category: {
                required: helpers.withMessage(
                    i18n.t("validation.required"),
                    required
                ),
            },

            contractNumber: {},

            occupation: {},

            comment: {},

            seller_id: {},
        };


        const v$ = useVuelidate(
            rules,
            requestMember,
            {
                $scope: "members",
            }
        );


        // ========================================================
        // Methods
        // ========================================================

        /**
         * Initialize member form.
         */
        const initState = (memberData: any = null) => {

            isInitializing.value = true;

            action.value = "edit";

            Object.assign(requestMember.value, {
                id: memberData?.id ?? null,
                card_id: memberData?.card_id ?? null,
                matricule: memberData?.matricule ?? null,
                name: memberData?.name ?? null,
                parent_name: memberData?.parent_name ?? null,
                email: memberData?.email ?? null,
                tele: memberData?.tele ?? null,
                cin: memberData?.cin ?? null,
                adresse: memberData?.adresse ?? null,

                gender: memberData?.gender ?? null,
                age_category: memberData?.age_category ?? null,

                dateBirth: memberData?.dateBirth ?? null,
                contractNumber: memberData?.contractNumber ?? null,
                occupation: memberData?.occupation ?? null,
                comment: memberData?.comment ?? null,
                seller_id: memberData?.seller_id ?? null,

                path_image: memberData?.path_image ?? null,

                sync_image_to_pointeuse:
                    memberData?.sync_image_to_pointeuse ?? true,
            });

            v$.value.$reset();

            /**
             * Wait until Vue finishes the current update cycle
             * before allowing watchers to react normally.
             */
            nextTick(() => {
                isInitializing.value = false;
            });
        };


        /**
         * Fetch sellers/employees.
         */
        const fetchDataEmployees = () => {
            fetchTrainers(searchByEmployees.value);
        };


        /**
         * Submit member form.
         */
        const submitForm = async () => {

            v$.value.$touch();

            if (v$.value.$invalid) {
                return;
            }

            const result = await Swal.fire({
                title: i18n.t("message.confirmation.edit.title"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: i18n.t("button.edit"),
                cancelButtonText: i18n.t("button.cancel"),
                allowOutsideClick: false,
                allowEscapeKey: false,
            });

            if (!result.isConfirmed) {
                return;
            }

            try {

                await editMember(
                    requestMember.value,
                    editFrom.value
                );

                if (editFrom.value === "fiche") {

                    initState(
                        fiche_member?.data?.member_info ?? null
                    );

                } else {

                    initState(null);

                }

                if (!errorMember.value) {
                    closeModal(
                        "modal_edit_member",
                        "edit"
                    );
                }

            } catch (error) {

                // Error handled by useMember()

            }
        };


        // ========================================================
        // Watchers
        // ========================================================

        /**
         * Initialize form when member prop changes.
         */
        watch(
            () => member.value,
            (newMember) => {
                initState(newMember);
            }
        );


        /**
         * Update image path when a new image is selected.
         */
        watch(
            () => selectedImage.value,
            (newImage) => {

                requestMember.value.path_image =
                    newImage;
            }
        );


        /**
         * Reset gender when age category changes manually.
         *
         * During initialization, gender must be preserved.
         */
        watch(
            () => requestMember.value.age_category,
            (newValue, oldValue) => {

                if (isInitializing.value) {
                    return;
                }

                if (newValue !== oldValue) {
                    requestMember.value.gender = null;
                    requestMember.value.parent_name = null;
                }

            }
        );


        // ========================================================
        // Initial Data
        // ========================================================

        fetchDataEmployees();


        // ========================================================
        // Return
        // ========================================================

        return {

            // State
            requestMember,
            action,
            isCaputre,

            // Computed
            filteredGenders,
            targetAgeList,
            employeesSellersList,

            // Validation
            v$,

            // Form actions
            submitForm,
            initState,

            // Image
            selectedImage,
            error,
            handleFileChange,

            // Composables
            isRequestMember,
            hasPermission,
            closeModal,

            // Config
            APP_URL,
            i18n,
        };
    },
});

</script>